<template>
  <div>
    <ml-header title="关于" :dark="true" />
    <div class="about-page">
      <img class="icon" src="../../assets/logo.png" alt="" />
      <p>PP社区</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "About"
};
</script>

<style lang="scss" scoped>
.about-page {
  padding-top: 40%;
  .icon {
    width: 78px;
    height: 78px;
  }
}
</style>
